/**
 * @file homepage lightbox SDNSW-7223
 * 
 * @author Brad Dong <bdong@squiz.net>
 * @date April 2020
 */        
(function ($) {
    'use strict';
      
      //wait for entire page to load
      $(window).on("load", function(module, exports) {
          
          var $lb = $('.lightbox_wrapper'); 
          var lbCookie = getCookie('Covid-lightbox');  
  
          if (lbCookie == null) {
            showLightbox();
          }
          
          function showLightbox() {
            setTimeout(function(){    //wait 4 secs after load to show
              $lb.css("display", "block");
              $(".lightbox_wrapper button").on("click", function () {
                  hideLightbox();
              });      
            }, 4000)
          }
          
          function hideLightbox() {
            $lb.css("display", "none");
            var dateNow = new Date();
            setCookie('Covid-lightbox', dateNow, 1);
          }
          
          function setCookie(name, value, days) {
            var expiresTime = '';
          
            if (days) {
              var date = new Date();
              date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);  //set cookie expiry
              expiresTime = "; expires=" + date.toUTCString();
            }
          document.cookie = name + "=" + (value || "") + expiresTime + "; path=/";
          }
          
          function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
            
              while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
              }
            
              if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
          
          return null;
          }
          
          
          //hide lightbox if clicked outside of lightbox, does not set cookie
          $('.lightbox_background').click(function(){
            $('.lightbox_wrapper').hide();
          })
      });        
          
  })(jQuery);
  
  
  